export const STATUS_ID_MAPPING = {
  callback: "0",
  fila: "1",
  tratamento: "2",
  retornando: "5",
};
